var map = {
	"./750-private-reserve.png": 5597,
	"./academy-promo-banner.webp": 4156,
	"./academy-promo-mobile-banner.webp": 5546,
	"./academy/academy-background.webp": 4687,
	"./academy/academy-banner-1.webp": 624,
	"./academy/academy-banner-2.webp": 8535,
	"./academy/academy-banner-3.webp": 1920,
	"./academy/academy-logo.webp": 9133,
	"./academy/and-more.webp": 5170,
	"./academy/anti-inflammatory.webp": 2102,
	"./academy/banner-1-mobile.webp": 7433,
	"./academy/banner-2-mobile.webp": 1923,
	"./academy/banner-3-mobile.webp": 6393,
	"./academy/bone-health.webp": 4607,
	"./academy/brain-health.webp": 8594,
	"./academy/cancer-prevention.webp": 3912,
	"./academy/choosing-olive-oil.webp": 3327,
	"./academy/dark-bottle.webp": 9583,
	"./academy/diabetes-prevention.webp": 7149,
	"./academy/extra-virgin.webp": 2212,
	"./academy/fresh-olive-oil.webp": 4084,
	"./academy/health-benefits.webp": 3855,
	"./academy/heart-health.webp": 6230,
	"./academy/immune-health.webp": 429,
	"./academy/mental-outlook.webp": 6367,
	"./academy/minimal-time.webp": 5037,
	"./academy/recipes.webp": 1802,
	"./academy/recipes/artichoke-hearts-in-olive-oil.webp": 9859,
	"./academy/recipes/cauliflower-salad-with-pomegranate.webp": 4480,
	"./academy/recipes/italian-pesto-zoodle-salad.webp": 4661,
	"./academy/recipes/menemen.webp": 6102,
	"./academy/recipes/romano-beans-in-olive-oil.webp": 5495,
	"./academy/recipes/strawberry-mint-salad.webp": 2719,
	"./academy/single-estate.webp": 5776,
	"./academy/transportation.webp": 9676,
	"./amex.webp": 9737,
	"./background-1.webp": 8928,
	"./background-3.webp": 4898,
	"./background.webp": 8797,
	"./black-friday-bg.webp": 655,
	"./black-friday-mobile-bg.webp": 551,
	"./cart-icon.webp": 8133,
	"./check-icon-stone.webp": 922,
	"./check-icon.webp": 2865,
	"./discount-icon.webp": 7828,
	"./discover.webp": 8456,
	"./down-arrow-green.webp": 2820,
	"./down-arrow.webp": 9122,
	"./email-icon.webp": 6399,
	"./email.webp": 4401,
	"./everyday-luxury.webp": 6337,
	"./facebook-icon.webp": 3611,
	"./farm.webp": 6799,
	"./founders.webp": 4820,
	"./gold-cart-icon.webp": 8078,
	"./gold-logo.webp": 5693,
	"./google-icon.webp": 7194,
	"./individual-bottles.webp": 9028,
	"./influencers/amber-wilson.webp": 782,
	"./influencers/aron-harrity.webp": 7697,
	"./influencers/iskra-apellido.webp": 8063,
	"./influencers/jarvis.webp": 8865,
	"./instagram-icon.webp": 9061,
	"./instagram.webp": 2634,
	"./location.webp": 6632,
	"./logo.webp": 7879,
	"./luxe-750.webp": 3753,
	"./luxe.webp": 2654,
	"./mastercard.webp": 8179,
	"./membership-options.webp": 8499,
	"./mobile-background.webp": 3906,
	"./mothers-day.webp": 3564,
	"./premium-750.webp": 6852,
	"./premium.webp": 3076,
	"./private-reserve-750.webp": 9472,
	"./private-reserve.webp": 5763,
	"./refined-palate.webp": 2004,
	"./restaurant-lineup.webp": 7536,
	"./shipping-icon.webp": 8118,
	"./tag-icon.webp": 9095,
	"./tasting-collection-cart.webp": 6022,
	"./tasting-collection.webp": 4787,
	"./tree-nobg.webp": 3302,
	"./tree.webp": 3690,
	"./true-connoisseur.webp": 4969,
	"./true-olive-bullet.webp": 7517,
	"./twitter-icon.webp": 2549,
	"./visa.webp": 698,
	"./whatsapp-icon.webp": 2432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;